import React from 'react';

function ViewCottage({ cottage, closeModal }) {
    if (!cottage) return null;

    function formatDateTime(isoString) {
        const date = new Date(isoString);
        const formattedDate = date.toLocaleDateString();
        const formattedTime = date.toLocaleTimeString();
        return { date: formattedDate, time: formattedTime };
    }
    const formatDate = (dateString) => {
        const date = new Date(dateString);

        // Check if the date is valid
        if (isNaN(date.getTime())) {
            return 'Invalid Date';
        }

        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear().toString();

        return `${day}-${month}-${year}`;
    };
    const url = 'uploads/';
    const { date, time } = formatDateTime(cottage.createdAt);
    const createMarkup = (htmlContent) => {
        return { __html: htmlContent };
    };

    return (
        <div className="modal fade viewbox edit-box show d-block" id="manufacturerModal" tabIndex={-1} aria-labelledby="manufacturerModal" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="manufacturerModal">Cottage Details</h5>
                        <button type="button" className="btn-close" onClick={closeModal} aria-label="Close"></button>
                    </div>
                    <div className="modal-body">

                        <div className="container">


                            {/* User Info Section */}
                            <div className="container-box user-manager" style={{ padding: "10px", marginTop: "15px" }}>
                                <ul className='user-details list-unstyled d-flex justify-content-between'>
                                    <li>
                                        <span>Cottage ID:</span>
                                        <p>#{cottage?.cottageId || 'N/A'}</p>
                                    </li>
                                    <li>
                                        <span>Cottage Name:</span>
                                        <p>{cottage?.name || 'N/A'}</p>
                                    </li>
                                    <li>
                                        <span>Location:</span>
                                        <p>{cottage?.location || 'N/A'}</p>
                                    </li>
                                </ul>
                                <ul className='user-details list-unstyled d-flex justify-content-between'>
                                    <li>
                                        <span>Capacity</span>
                                        <p>{cottage?.guestCapacity || 'N/A'}</p>
                                    </li>
                                    <li>
                                        <span>Base Price</span>
                                        <p>₹{cottage?.price || 'N/A'}</p>
                                    </li>
                                    <li>
                                        <span>Offer Price</span>
                                        <p>₹{cottage?.offerPrice || 'N/A'}</p>
                                    </li>
                                </ul>
                                <ul className='user-details list-unstyled d-flex justify-content-between'>
                                    <li>
                                        <span>GST Tax(%)</span>
                                        <p>{cottage?.tax || 'N/A'}</p>
                                    </li>
                                    <li>
                                        <span>Status</span>
                                        <p>{cottage?.status || 'N/A'}</p>
                                    </li>

                                </ul>
                            </div>
                            <div className="container-box user-manager" style={{ padding: "10px", marginTop: "15px" }}>
                                <h4>Images:</h4>
                                <ul className='user-details list-unstyled d-flex justify-content-between'>
                                    <li className='text-start'>
                                        {/* <span>Cottage Name</span> */}
                                        <p>
                                            {cottage?.images?.map((image, index) => (
                                                <img
                                                    key={index}
                                                    src={process.env.REACT_APP_URL + image}
                                                    alt={`Cottage Image ${index + 1}`}
                                                    style={{ height: '100px', width: '100px', objectFit: 'cover', marginRight: '10px' }}
                                                />
                                            ))}
                                        </p>

                                    </li>
                                </ul>
                            </div>
                            <div className="container-box user-manager" style={{ padding: "10px", marginTop: "15px" }}>
                                <h4>Description:</h4>
                                <ul className='user-details list-unstyled d-flex justify-content-between'>
                                    <li className='text-start'>
                                        {/* <p>{cottage?.description || 'N/A'}</p> */}
                                        <div dangerouslySetInnerHTML={createMarkup(cottage?.description || 'N/A')} />
                                    </li>
                                </ul>
                            </div>
                            <div className="container-box user-manager" style={{ padding: "10px", marginTop: "15px" }}>
                                <h4>Accommodation Details</h4>
                                <ul className='user-details list-unstyled d-flex justify-content-between'>
                                    <li>
                                        <span>Number of Rooms</span>
                                        <p>{cottage?.guestCapacity || 'N/A'}</p>
                                    </li>
                                    <li>
                                        <span>Number of Beds</span>
                                        <p>{cottage?.price || 'N/A'}</p>
                                    </li>
                                    <li>
                                        <span>Number of Bathrooms</span>
                                        <p>{cottage?.offerPrice || 'N/A'}</p>
                                    </li>
                                </ul>
                            </div>
                            <div className="container-box user-manager" style={{ padding: "10px", marginTop: "15px" }}>
                                <h4>Amenities</h4>
                                <ul className='user-details list-unstyled d-flex justify-content-between'>
                                    <li className='text-start'>
                                        {cottage?.swimmingPool && <p>Swimming Pool</p>}
                                        {cottage?.ac && <p>Air Conditioning</p>}
                                        {cottage?.wifi && <p>WiFi</p>}
                                        {cottage?.parking && <p>Parking</p>}
                                        {cottage?.livingArea && <p>Living Area</p>}
                                    </li>
                                </ul>
                            </div>

                            <div className="modal-footer d-flex">
                                <button type="button" className="site-btn-green" style={{ marginBlock: '15px', backgroundColor: '#699836' }} onClick={closeModal}>
                                    CLOSE
                                </button>
                            </div>

                        </div>


                    </div>
                </div>

            </div>
        </div>
    );
}

export default ViewCottage;
